// Pure role derivations for AuthContext. Kept dependency-free (no React,
// no api.js) so the gates are unit-testable in the node test env without
// pulling in modules that touch `window` at import time.

// Platform-admin flag (CLAUDE.md AuthContext contract). While
// impersonating, a vista_admin acts as org_admin, so this is false in
// that mode (matches the forced `role` in the context value).
export function deriveIsVistaAdmin(user, impersonating) {
  return !impersonating && user?.role === 'vista_admin';
}

// Assemble the AuthContext value object from session state + the
// impersonation record. Extracted (pure, dependency-free) so the wiring
// itself is unit-testable — including the `isVistaAdmin` key whose
// absence (a latent gap since S14-5: UpdateButton read it but it was
// never set in the value object) hid the Update control. Importing
// AuthContext.jsx in a node test drags in api.js, which touches `window`
// at module load, so the assembly lives here instead.
export function buildAuthValue(state, imp, callbacks = {}) {
  return {
    user: state.user,
    loading: state.loading,
    error: state.error,
    errorType: state.errorType,
    isAuthenticated: !!state.user,
    role: imp ? 'org_admin' : (state.user?.role || null),
    isVistaAdmin: deriveIsVistaAdmin(state.user, imp),
    orgId: imp ? imp.org_id : (state.user?.org_id || null),
    orgName: imp ? imp.org_name : (state.user?.org_name || null),
    networkServicesEnabled: !!state.user?.network_services_enabled,
    impersonating: imp,
    refetch: callbacks.refetch,
    startImpersonation: callbacks.startImpersonation,
    endImpersonation: callbacks.endImpersonation,
  };
}
